<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item has-feedback :label="$t('类型编码')">
              <a-input :disabled="!!model.id" v-decorator="['utCode',validatorRules.utCode]" :placeholder="$t('请输入类型编码')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item has-feedback :label="$t('类型名称')">
              <a-input :disabled="!!model.id" v-decorator="['utName',validatorRules.utName]" :placeholder="$t('请输入类型名称')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('优惠水量')">
              <a-input-number :disabled="disabled" v-decorator="['utFreeCount']" :placeholder="$t('请输入该类用户优惠水量')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('优惠百分比')">
              <a-input-number :disabled="disabled" v-decorator="['utFreePercent']" :placeholder="$t('请输入该类用户优惠百分比')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('优惠类型')">
              <a-input-number :disabled="disabled" v-decorator="['utFreeType']" :placeholder="$t('请输入优惠类型')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('备注')">
              <a-textarea :disabled="disabled" v-decorator="['utRemark']" rows="2" :placeholder="$t('请输入备注说明')"/>
            </a-form-item>
          </a-col>

          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{ $t('提 交') }}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import {isUndefined} from'@/utils/validate'
  import { mapGetters } from 'vuex'

  export default {
    name: 'MeterUserTypeForm',
    components: {
      JFormContainer,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterUserType/add",
          edit: "/jeecg-charge/meter/meterUserType/edit",
          queryById: "/jeecg-charge/meter/meterUserType/queryById",
          queryMeterUserTypeByUserId: "/jeecg-charge/meter/meterUserType/list"
        }
      }
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      validatorRules() {
        return {
          utCode:{rules: [{ required: true, message: this.$t('请输入类型编码!') },
            {validator: this.validateUtCode}
          ]},
          utName:{rules: [{ required: true, message: this.$t('请选择类型名称') },
            {validator: this.validateUtName}
          ]},
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
    },
    methods: {
      ...mapGetters(["userInfo"]),
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'utCode','utName','utFreeCount','utFreePercent','utRemark','utFreeType','createTime','createBy'))
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'utCode','utName','utFreeCount','utFreePercent','utRemark','utFreeType','createTime','createBy'))
      },
      // 查询类型代码是否重复
      validateUtCode(rule, value, callback) {
        if(isUndefined(value)||value.replace(/\s+/g,'') == '') {
          callback("")
          return
        }
        let org = this.userInfo().orgCode
        let utCode = this.form.getFieldValue('utCode').trim();
        this.form.setFieldsValue({utCode: utCode});
        let params = {utCode: utCode,sysOrgCode: org}
        getAction(this.url.queryMeterUserTypeByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t("该类型代码已存在!"))
            }
          } else {
            callback()
          }
        })
      },
      // 查询类型代码是否重复
      validateUtName(rule, value, callback) {
        if(isUndefined(value)||value.replace(/\s+/g,'') == '') {
          callback("")
          return
        }
        let org = this.userInfo().orgCode
        let utName = this.form.getFieldValue('utName').trim();
        this.form.setFieldsValue({utName: utName});
        let params = {utName: utName,sysOrgCode: org}
        getAction(this.url.queryMeterUserTypeByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t("该类型名称已存在!"))
            }
          } else {
            callback()
          }
        })
      },
    }
  }
</script>